import { Swiper, Navigation, Pagination, Thumbs, Controller } from 'swiper';
import elementExists from "../../core/utils/element-exists"

const RelatedContentSwiper = function () {
        const swiperRecipeRelated = document.querySelectorAll( '.related-content' );
        if ( Object.keys(swiperRecipeRelated).length ) {
            // Related Recipes Section
            swiperRecipeRelated.forEach( function( el ){
                const container = el;
                const swiperContainer = container.querySelector( '.swiper');
                let btnNext = container.querySelector('.swiper-button-next');
                let btnPrev = container.querySelector('.swiper-button-prev');
                if( elementExists( swiperContainer)){
                    const swiper = new Swiper( swiperContainer , {
                        direction: 'horizontal',
                        slidesPerView: 'auto',
                        spaceBetween: 30,
                        navigation: {
                            nextEl: btnNext,
                            prevEl: btnPrev
                        },
                        breakpoints: {
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 60
                            },
                            1192: {
                                slidesPerView: 3,
                                spaceBetween: 120
                            }
                        }
                    })
                }
            });
        }


}
  

export default RelatedContentSwiper;